import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import EmployeeHandbook from "./index";
import { Award } from "lucide-react";

const houseRulesRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Employee Handbook",
		basePath: "employee-handbook",
		mainComponent: <EmployeeHandbook />,
	    layout: "/console",	   
	    icon: <Award className="icon-item" />,
	    subTitle:"Employee Handbook",
		level:5,
		moduleId: 0,
	})
]

export default houseRulesRoutes;